<template>
	<div class="Ymx_authorization">
		<el-form :inline="true" :model="formScreen" ref="formScreen">
			<el-form-item
				label="选择分公司"
				prop="branchCompany"
				v-if="[1].includes(str.type)"
			>
				<el-select
					v-model="formScreen.branchCompany"
					placeholder="请选择"
					@change="selectChange($event, 'sonCompany')"
					value-key="company_id"
					filterable
				>
					<el-option
						v-for="item in branchCompany"
						:key="item.company_id"
						:label="item.companyName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				label="选择子公司"
				prop="sonCompany"
				v-if="[2, 1].includes(str.type)"
			>
				<el-select
					v-model="formScreen.sonCompany"
					placeholder="请选择"
					value-key="rid"
					@change="selectChange($event, 'branchDepartmentList')"
					filterable
				>
					<el-option
						v-for="item in sonCompany"
						:key="item.company_id"
						:label="item.companyName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="选择部门">
                <el-select
                    v-model="formScreen.departmentValue"
                    placeholder="请选择"
                    @change="selectChange($event, 'branchDepartmentList')"
                    :disabled="str.system >= 2"
                    value-key="rid"
                >
                    <el-option
                        v-for="item in departmentList"
                        :key="item.value"
                        :label="item.departmentName"
                        :value="item"
                    ></el-option>
                </el-select>
            </el-form-item> -->
			<el-form-item label="选择运营分部门" prop="branchDepartmentValue">
				<el-select
					v-model="formScreen.branchDepartmentValue"
					placeholder="请选择"
					@change="selectChange($event, 'groupList')"
					value-key="rid"
				>
					<el-option
						v-for="item in branchDepartmentList"
						:key="item.value"
						:label="item.departmentName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="选择组" prop="groupValue">
				<el-select
					v-model="formScreen.groupValue"
					placeholder="请选择"
					@change="selectChange($event, 'userList')"
					value-key="rid"
				>
					<el-option
						v-for="item in groupList"
						:key="item.value"
						:label="item.groupName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择角色" prop="userValue">
				<el-select
					v-model="formScreen.userValue"
					placeholder="请选择"
					@change="selectChange($event)"
					value-key="rid"
				>
					<el-option
						v-for="item in userList"
						:key="item.value"
						:label="item.roleUserName"
						:value="item"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-row>
					<el-input
						v-model="SearchInp"
						placeholder="店铺名称、商铺id"
						style="width:250px;"
					></el-input>
					<el-button
						type="primary"
						@click="Search2"
						size="mini"
						style="margin-left:10px;padding:7px 15px;"
						>搜索</el-button
					>
					<el-button
						type="primary"
						@click="formScreenReset"
						size="mini"
						style="padding:7px 15px;"
						>重置</el-button
					>
				</el-row>
			</el-form-item>
		</el-form>

		<div class="top">
			<el-button
				type="primary"
				@click="addAuthorization"
				v-if="![2, 1].includes(str.type)"
				>添加授权</el-button
			>
			<el-button type="text" @click="chakan">查看授权帮助</el-button>
		</div>
		<div class="bottom" v-if="![2, 1].includes(str.type)">
			<div class="bottom-left left">说明！</div>
			<div class="bottom-right left">
				<p>1.多店铺授权，防关联;</p>
				<p>2.同一店铺不可重复授权;</p>
				<p>3.授权删除，不影响平台数据;</p>
				<p>4.同一运营角色不可绑定相同国家的不同店铺。</p>
			</div>
		</div>
		<div class="ymx_in">
			<el-table
				:data="tableData"
				border
				style="width: 100%;margin-bottom:50px;"
				v-loading="loadingTable"
			>
				<el-table-column
					prop="shop_name"
					label="店铺名称"
				></el-table-column>
				<el-table-column
					prop="sellerId"
					label="商户ID"
				></el-table-column>
				<el-table-column label="授权国家">
					<template slot-scope="scope">
						<div
							v-for="item in tableCountry[scope.$index]"
							:key="item.id"
						>
							{{ item.countryName }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="authorization_time"
					label="授权时间"
				></el-table-column>
				<el-table-column
					prop="operationName"
					label="运营部/角色"
				></el-table-column>
				<el-table-column
					prop="purchaseName"
					label="采购人员"
				></el-table-column>
				<el-table-column
					width="200"
					prop="fenName"
					label="所属分公司"
					align="center"
					v-if="str.type === 1"
				></el-table-column>
				<el-table-column
					width="200"
					prop="ziName"
					label="所属子公司"
					align="center"
					v-if="[1, 2].includes(str.type)"
				></el-table-column>
				<el-table-column
					fixed="right"
					label="操作"
					width="230"
					v-if="str.type === 3"
				>
					<template slot-scope="scope">
						<div>
							<el-button
								@click="handleClick(scope.row)"
								type="text"
								size="small"
								>更改店铺信息</el-button
							>
						</div>
						<div>
							<el-button
								@click="Delete(scope.row)"
								type="text"
								size="small"
								>删除</el-button
							>
						</div>
						<div>
							<el-button
								@click="distribution(scope.row)"
								type="text"
								size="small"
								>分配</el-button
							>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="page">
				<el-pagination
					style="margin-right:200px;"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[50, 100, 200, 400]"
					:page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>

		<el-dialog
			title="修改相关信息"
			:visible.sync="EditName"
			width="30%"
			style="margin-top:20px;"
		>
			<div>
				<label style="display: inline-block;width: 100px;">名称：</label
				><el-input
					placeholder="请输入要修改的店铺名称"
					v-model="NameValue1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<div>
				<label style="display: inline-block;width: 100px;"
					>授权令牌：</label
				><el-input
					placeholder="请输入要修改的授权令牌"
					v-model="mwsAuthTokenValue1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<div>
				<label style="display: inline-block;width: 100px;"
					>Amazon账号：</label
				><el-input
					disabled
					v-model="amazon_id1"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<div>
				<label style="display: inline-block;width: 100px;">
					开发者id：</label
				><el-input
					v-model="developerId"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div>
			<p class="hint mt">例如：1234-1234-1234 或 123412341234</p>
			<!-- <div v-if="IOSS">
				<label style="display: inline-block;width: 100px;">
					IOSS：</label
				><el-input
					v-model="iossCode"
					placeholder="2位字母加十位数字"
					style="margin-top:10px;width:70%;"
				></el-input>
			</div> -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="EditName = false">取 消</el-button>
				<el-button type="primary" @click="Submit">提 交</el-button>
			</div>
		</el-dialog>

		<el-dialog
			title="店铺分配"
			:visible.sync="shopDistribution"
			width="25%"
			style="margin-top:20px;"
		>
			<el-form
				class="custom-form"
				ref="form"
				label-width="100px"
				label="left"
			>
				<el-form-item label="选择部门">
					<el-select
						v-model="value1"
						@change="choose1"
						placeholder="请选择"
					>
						<el-option
							v-for="item1 in this.arr1"
							v-if="
								item1.departmentName == '运营部' ||
									item1.departmentName == '采购部'
							"
							:key="item1.value"
							:label="item1.departmentName"
							:value="item1"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择分部门" v-show="isShow">
					<el-select
						v-model="value2"
						@change="choose2"
						placeholder="请选择"
					>
						<el-option
							v-for="item2 in this.arr2"
							:key="item2.value"
							:label="item2.departmentName"
							:value="item2"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择组" v-show="isShow">
					<el-select
						v-model="value3"
						@change="choose3"
						placeholder="请选择"
					>
						<el-option
							v-for="item3 in this.arr3"
							:key="item3.value"
							:label="item3.groupName"
							:value="item3"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择员工">
					<el-select
						v-model="value4"
						@change="choose4"
						placeholder="请选择"
					>
						<el-option
							v-for="item4 in this.arr4"
							:key="item4.value"
							:label="item4.roleName"
							:value="item4"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="shopDistribution = false">取消</el-button>
				<el-button
					type="primary"
					@click="Submit1"
					:loading="loadingStatus"
					>分配</el-button
				>
			</div>
		</el-dialog>

		<el-dialog
			title="添加授权"
			:visible.sync="authorization"
			width="40%"
			:show-close="false"
		>
			<p class="line">开发者名称输入：<span class="point">hyxun</span></p>
			<p class="line">开发者ID，不同站点，输入不同的ID:</p>
			<p class="line">
				美洲站 输入:
				<span class="col Col1">2930-1459-3338(无法访问)</span>
			</p>
			<p class="line">
				欧洲站、阿联酋、沙特阿拉伯 输入:
				<span class="col Dis">8234-6836-8234(无法访问)</span>
				<span class="col Col2">3888-0595-5981 (无法访问)</span>
			</p>
			<p class="line">
				澳洲站 输入:
				<span class="col Dis">9544-7254-2632(无法访问)</span>
				<span class="col Col3">4044-6614-4288(无法访问)</span>
			</p>
			<p class="line">
				日本站、新加坡 输入:
				<span class="col Col4">4044-6614-4288(无法访问)</span>
			</p>
			<div class="site-box clear">
				<div class="input">
					<span class="input-label">Merchant ID：</span>
					<el-input
						v-model.trim="sellerId"
						placeholder="卖家编号"
						style="margin-top: 5px;width: 400px;"
					></el-input>
					<el-button
						type="primary"
						size="mini"
						class="sure"
						@click="determine"
						>确定</el-button
					>
				</div>
				<el-button type="text" @click="chakan" style="float:right;"
					>如何获取上述信息？</el-button
				>
			</div>

			<div style="margin-top:30px;" v-show="isShow1">
				<div class="input">
					<span class="left inputspan">MWSAuth Token：</span>
					<el-input
						v-model.trim="mwsAuthToken"
						placeholder="亚马逊授权令牌码"
						style="margin-top: 5px;width: 70%;"
					></el-input>
				</div>
				<div class="input">
					<span class="left inputspan">店铺别名:</span>
					<el-input
						v-model="shop_name"
						placeholder="请输入店铺别名"
						class="left"
						style="margin-top: 5px;width: 70%;"
					></el-input>
				</div>
				<div class="input inputspan">
					<span class="left inputspan">Amazon账号:</span>
					<el-input
						v-model="amazon_id"
						placeholder="请输入账号"
						class="left"
						style="margin-top: 5px;width: 70%;"
					></el-input>
				</div>
				<div class="input">
					<span class="left inputspan">开户站:</span>
					<el-select
						v-model="country_mark"
						placeholder="请选择"
						class="left"
						@change="countryChange"
					>
						<el-option
							v-for="item in selList"
							:key="item.value"
							:label="item.countryName"
							:value="item.id"
						></el-option>
					</el-select>
				</div>
				<div class="input inputspan">
					<span class="left inputspan">开发者ID:</span>
					<el-input
						v-model="developerId"
						placeholder="请输入开发者ID"
						class="left"
						style="margin-top: 5px;width: 70%;"
					></el-input>
				</div>
				<p class="hint">例如：1234-1234-1234 或 123412341234</p>
				<!-- <div class="input inputspan" v-if="selIOSS">
					<span class="left inputspan">IOSS:</span>
					<el-input
						v-model="iossCode"
						placeholder="2位字母加十位数字"
						class="left"
						style="margin-top: 5px;width: 70%;"
					></el-input>
				</div> -->
			</div>
			<div class="el-dialog__footer">
				<el-button type="primary" @click="clickAddtion">授权</el-button>
				<el-button @click="Cancel">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
export default {
	name: 'Ymx_authorization',
	data() {
		return {
			// IOSS: false,
			// selIOSS: false,
			authorization: false,
			EditName: false,
			shopDistribution: false,
			isShow1: false,
			currentPage: 1,
			pagesize: 50,
			size: 50,
			total: 0,
			isShow: true,
			arr1: '',
			arr2: '',
			arr3: '',
			arr4: '',
			value1: '',
			value2: '',
			value3: '',
			value4: '',
			sellerId: '',
			NameValue: '',
			mwsAuthTokenValue: '',
			mnumber: '',
			Brandcode: '',
			str: '',
			shop_name: '',
			// iossCode: '',
			country_mark: '',
			mwsAuthToken: '',
			amazon_id: '',
			selList: '',
			tableData: [],
			tableCountry: [],
			departmentId: '',
			departmentChildId: '',
			sid: '',
			gid: '',
			rid: '',
			branchCompany: [],
			sonCompany: [],
			departmentList: [],
			branchDepartmentList: [],
			groupList: [],
			userList: [],
			formScreen: {
				branchCompany: {},
				sonCompany: {},
				departmentValue: {},
				branchDepartmentValue: {},
				groupValue: {},
				userValue: {},
			},

			loadingTable: false,
			loadingStatus: false,
			isAccept: '',
			SearchInp: '',

			sellerId1: '',
			NameValue1: '',
			mwsAuthTokenValue1: '',
			amazon_id1: '',
			developerId: '',
		}
	},
	mounted() {},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.init()
		this.selectList()
	},
	methods: {
		selectList() {
			ajaxPost(Baseurl + 'sellerController/getAllCountry').then((res) => {
				// console.log(res.data)
				const { code, data } = res.data
				console.log(JSON.parse(JSON.stringify(data)))
				if (code === 200) {
					this.selList = data
				}
			})
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
			} = this.str
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'branchDepartmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else {
				return
			}
			this.tableList(type, companyId, rid, system)
		},
		tableList(
			type,
			company_id = this.str.company_id,
			rid = this.str.rid,
			system = this.str.system
		) {
			this.loadingTable = true
			const paramsData = {
				page: this.currentPage,
				size: this.size,
				company_id,
				rid,
				system,
			}
			ajaxPost(
				Baseurl + 'sellerController/selectSellerByCompany_id',
				paramsData
			).then((res) => {
				const { code, data } = res.data
				this.loadingTable = false
				if (code === 200) {
					const {
						next = [],
						sellerInfo: { list, total },
					} = data
					this[type] = next
					this.tableData = list
					this.total = total
					this.tableCountry = []
					for (var i = 0; i < list.length; i++) {
						this.tableCountry.push(list[i].countryMarks)
					}
				}
				// console.log(this.tableData)
			})
		},
		countryChange(val) {
			this.country_mark = val
			// this.selList.forEach((item) => {
			// 	if (item.id === val) {
			// 		if (item.area == 'EUR') {
			// 			this.selIOSS = true
			// 		} else {
			// 			this.selIOSS = false
			// 		}
			// 	}
			// })
			// console.log(this.country_mark)
		},
		addAuthorization() {
			this.developerId = ''
			this.authorization = true
		},
		determine() {
			if (this.sellerId === '') {
				this.$message.error('卖家编号不能为空')
			} else {
				var sellerId = { sellerId: this.sellerId }
				ajaxPost(
					Baseurl + 'sellerController/selectSellerBySellerId',
					sellerId
				).then((res) => {
					// console.log(res.data)
					if (res.data.code == 200) {
						if (res.data.data == null) {
							this.isShow1 = true
							this.mwsAuthToken = ''
							this.shop_name = ''
							this.amazon_id = ''
						} else {
							this.mwsAuthToken = res.data.data.mwsAuthToken
							this.shop_name = res.data.data.shop_name
							this.amazon_id = res.data.data.amazon_id
							this.isShow1 = true
						}
					}
				})
			}
		},
		clickAddtion() {
			// name:'店铺别名',anumber:'Amazon账号',value:'开户站', mnumber:'卖家编号',Brandcode:'亚马逊授权令牌码',
			if (this.sellerId === '') {
				this.$message.error('卖家编号不能为空')
			} else if (this.mwsAuthToken === '') {
				this.$message.error('MWSAuth Token不能为空')
			} else if (this.shop_name === '') {
				this.$message.error('店铺别名不能为空')
			} else if (this.amazon_id === '') {
				this.$message.error('Amazon账号不能为空')
			} else if (this.country_mark === '') {
				this.$message.error('开户站点不能为空')
			} else {
				// if (this.selIOSS) {
				// 	let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
				// 	if (!str.test(this.iossCode)) {
				// 		this.$message.error('IOSS格式为12位字母+数字组合')
				// 		return
				// 	}
				// }

				var obj = {
					company_id: this.str.company_id,
					// iossCode: this.iossCode,
					shop_name: this.shop_name,
					sellerId: this.sellerId,
					mwsAuthToken: this.mwsAuthToken,
					amazon_id: this.amazon_id,
					countryMarks: [{ id: this.country_mark }],
					developerId: this.developerId,
				}
				ajaxPost(
					Baseurl + 'sellerController/insertSellerInfo',
					obj
				).then((res) => {
					// console.log(res.data)
					if (res.data.code == 200) {
						this.$message({
							message: '添加授权成功',
							type: 'success',
						})
						this.init()
					} else if (res.data.code == 500) {
						this.$message.error(res.data.data)
					}
				})
				this.isShow1 = false
				this.authorization = false
				this.shop_name = ''
				this.country_mark = ''
				this.sellerId = ''
				this.mwsAuthToken = ''
				this.amazon_id = ''
			}
		},
		Cancel() {
			this.shop_name = ''
			this.country_mark = ''
			this.sellerId = ''
			this.mwsAuthToken = ''
			this.amazon_id = ''

			this.isShow1 = false
			this.authorization = false
		},
		handleClick(item) {
			this.EditName = true
			// console.log(JSON.parse(JSON.stringify(item)))
			// item.countryMarks.area
			// IOSS
			// item.countryMarks.forEach((val) => {
			// 	if (val.area == 'EUR') {
			// 		this.IOSS = true
			// 	} else {
			// 		this.IOSS = false
			// 	}
			// })
			// this.iossCode = item.iossCode
			this.sellerId1 = item.sellerId
			this.NameValue1 = item.shop_name
			this.mwsAuthTokenValue1 = item.mwsAuthToken
			this.amazon_id1 = item.amazon_id
			this.developerId = item.developerId
		},
		Submit() {
			// console.log()
			// return
			// if (this.IOSS) {
			// 	let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
			// 	if (!str.test(this.iossCode)) {
			// 		this.$message.error('IOSS格式为12位字母+数字组合')
			// 		return
			// 	}
			// }

			var obj = {
				sellerId: this.sellerId1,
				shop_name: this.NameValue1,
				mwsAuthToken: this.mwsAuthTokenValue1,
				developerId: this.developerId,
				// iossCode: this.iossCode,
			}
			ajaxPost(
				Baseurl + 'sellerController/updateShopNameBySellerId',
				obj
			).then((res) => {
				// console.log(res.data)
				if (res.data.code == 200) {
					this.$message({
						message: '修改店铺名成功',
						type: 'success',
					})
					this.init()
				} else {
					this.$message.error(res.data.data)
				}
			})
			this.NameValue = ''
			this.EditName = false
		},
		chakan() {
			this.$router.push({
				path: '/jurisdiction/Ymx_authorization_help',
				name: 'Ymx_authorization_help',
			})
		},
		Delete(item) {
			// console.log(item)
			this.$confirm('确认删除此条数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = { id: item.id }
					ajaxPost(
						Baseurl + 'sellerController/deleteSellerInfo',
						obj
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.init()
						} else {
							this.$message.error('删除失败')
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`)
			this.size = val
			this.init()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`)
			this.currentPage = val
			this.init()
		},
		distribution(val) {
			// console.log(val)
			this.sid = val.id
			this.shopDistribution = true
			var company_id = {
				company_id: this.str.company_id,
			}
			ajaxPost(
				Baseurl + 'roleController/selectDepartmentByCompanyId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr1 = res.data.data
				}
			})
		},
		choose1(val) {
			this.departmentId = val.did
			// console.log(val)
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''

			if (val.kind === 0) {
				this.isShow = true
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr2 = res.data.data.next
					}
				})
			} else if (val.kind === 1) {
				this.departmentChildId = ''
				this.gid = ''
				this.isShow = false
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr4 = res.data.data.next
					}
				})
			}
		},
		choose2(val) {
			this.departmentChildId = val.did
			// console.log(val)
			this.arr3 = []
			this.arr4 = []
			this.value3 = ''
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 3,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr3 = res.data.data.next
				}
			})
		},
		choose3(val) {
			this.gid = val.gid
			// console.log(val)
			this.arr4 = []
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 4,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr4 = res.data.data.next
				}
			})
		},
		choose4(val) {
			this.rid = val.rid
			// console.log(val)
		},
		Submit1() {
			this.$confirm('是否分配该店铺当前时间之前的所有订单', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
			})
				.then(() => {
					this.isAccept = 1
					this.submitAjax()
				})
				.catch(() => {
					this.isAccept = 0
					this.submitAjax()
				})
		},
		submitAjax() {
			var obj = {
				departmentId: this.departmentId,
				departmentChildId: this.departmentChildId,
				gid: this.gid,
				rid: this.rid,
				sid: this.sid,
				isAccept: this.isAccept,
			}
			// console.log(obj);
			this.loadingStatus = true
			ajaxPost(Baseurl + 'sellerController/allotSeller', obj).then(
				(res) => {
					this.loadingStatus = false
					if (res.data.code == 200) {
						this.$message({
							message: '分配店铺成功',
							type: 'success',
						})
						this.init()
						this.shopDistribution = false
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		selectChange(item, type) {
			if (type === 'sonCompany') {
				this.formScreen.sonCompany = {}
				this.formScreen.departmentValue = {}
				this.formScreen.groupValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
			} else if (type === 'departmentList') {
				this.formScreen.departmentValue = {}
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.departmentList = []
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'branchDepartmentList') {
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'groupList') {
				this.formScreen.groupValue = {}
				this.formScreen.userValue = {}
				this.groupList = []
				this.userList = []
			} else if (type === 'userList') {
				this.formScreen.userValue = {}
				this.userList = []
			}
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
			} = item
			this.tableList(type, companyId, rid, system)
		},
		formScreenQuery() {},
		formScreenReset() {
			this.currentPage = 1
			this.$refs.formScreen.resetFields()
			this.branchCompany = []
			this.sonCompany = []
			this.departmentList = []
			this.branchDepartmentList = []
			this.groupList = []
			this.userList = []
			this.SearchInp = ''
			this.init()
		},
		Search2() {
			this.currentPage = 1
			this.Search()
		},
		Search() {
			this.loadingTable = true
			var obj = {
				companyId: this.str.company_id,
				str: this.SearchInp,
				page: this.currentPage,
				size: this.size,
			}
			ajaxPost(
				Baseurl + 'sellerController/selectByNameOrSellerId',
				obj
			).then((res) => {
				if (res.data.code === 200) {
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.tableCountry = []
					for (var i = 0; i < this.tableData.length; i++) {
						this.tableCountry.push(this.tableData[i].countryMarks)
					}
				}
			})
			this.loadingTable = false
		},
	},
}
</script>

<style lang="scss">
.hint {
	padding-left: 130px;
	color: red;
	margin-top: -15px;
}
.mt {
	margin-top: 0 !important;
	padding-left: 110px;
}
.Ymx_authorization {
	width: 98%;
	.el-button {
		padding: 9px 15px;
	}
	.cell {
		padding-left: 0;
		text-align: center;
	}
	.bottom {
		margin-top: 30px;
		.bottom-left {
			padding: 2px 4px 2px 15px;
			background-color: #f56c6c;
			margin-right: 20px;
			color: #fff;
		}
		.left {
			float: left;
		}
		.bottom-right p {
			margin-bottom: 10px;
			color: #f56c6c;
		}
	}
	.ymx_in {
		margin-top: 30px;
	}
	.input {
		overflow: hidden;
		margin-bottom: 15px;
		.inputspan {
			width: 130px;
			line-height: 40px;
		}
	}
	.line {
		font-size: 15px;
		padding-bottom: 10px;
		color: #000;
	}

	.point {
		color: red;
		font-weight: bold;
		font-size: 16px;
	}
	.col {
		font-weight: bold;
		font-size: 16px;
		margin-right: 25px;
	}
	.Col1 {
		color: #eb3c00;
	}
	.Col2 {
		color: coral;
	}
	.Col3 {
		color: skyblue;
	}
	.Col4 {
		color: #0daa69;
	}
	.Dis {
		color: #ccc;
	}
	.site-box {
		width: 100%;
		background-color: #ddd;
		border: 1px solid #cdcdcd;
		border-radius: 5px;
		padding: 10px 0 40px;
		.input-label {
			display: inline-block;
			width: 150px;
			text-align: right;
		}
	}
	.el-dialog__footer {
		padding: 10px 20px 20px;
		text-align: right;
		box-sizing: border-box;
	}
	.sure {
		margin-left: 30px;
	}
	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
	}
	.el-form-item__label {
		text-align: justify;
	}
	.custom-form.el-form {
		width: 330px;
		margin: auto;
	}
}
</style>
